import React from "react"

const Spinner = props => {
	let spinner = (
		<div key='spinner' className='lds-ripple'>
			<div></div>
			<div></div>
		</div>
	)
	if (props.type === "fullPage") {
		spinner = (
			<div className='spinner__fullPage' key='spinner'>
				<div className='lds-ripple'>
					<div></div>
					<div></div>
				</div>
			</div>
		)
	}

	return [spinner]
}

// const Spinner = () => (
//     <div className="lds-ripple"><div></div><div></div></div>
// );

export default Spinner
